module.exports = __webpack_public_path__ + "img/gastronomia-h.204ef03a.png";